export default {
  new: 'new',
  new_Color: 'red',

  customer_contacted: 'customer_contacted',
  customer_contacted_color: 'orange',

  //READY FOR DESIGN
  ready_to_design: 'ready_to_design',
  ready_to_design_color: 'pink',

  //DESIGN STARTED
  designing_started: 'designing_started',
  designing_started_color: 'yellow',

  //DESIGN STARTED
  new_design_added: 'new_design_added',
  new_design_added_color: 'new_design_added',

  //CLIENT CHECKING DESIGN
  clnt_chckng_dsgn: 'clnt_chckng_dsgn',
  clnt_chckng_dsgn_color: 'brown',

  //CLIENT REJECTED DESIGN
  clnt_rejectd_dsgn: 'clnt_rejectd_dsgn',
  clnt_rejectd_dsgn_color: 'red',

  //CLIENT APPROVED DESIGN
  clnt_apprvd_dsgn: 'clnt_apprvd_dsgn',
  clnt_apprvd_dsgn_color: 'violet',

  //DESIGN
  designing: 'designing',
  designing_color: 'teal',

  //START DESIGNING KIMOTO
  start_dsng_kimoto: 'start_dsng_kimoto',
  start_dsng_kimoto_color: 'purple',

  //FINISH DESIGNING KIMOTO
  fin_dsng_kimoto: 'fin_dsng_kimoto',
  fin_dsng_kimoto_color: 'purple',

  //FIND SHIRT STATUS..
  find_shirt: 'find_shirt',
  find_shirt_color: 'purple',

  //SHIRT FOUND
  shirt_found: 'shirt_found',
  shirt_found_status: 'teal',

  printing: 'printing',
  printing_color: 'violet',

  packing: 'packing',
  packing_color: 'purple',

  out_delivery: 'out_delivery',
  out_delivery_color: 'pink',

  delivered: 'delivered',
  delivered_color: 'green',

  cancelled: 'cancelled',
  cancelled_color: 'cancelled_color',

  materials_ok: 'materials_ok',

  lost: 'lost',
  lost_color: 'purple',

  refused: 'refused',
  refused_color: 'brown',

  //START DESIGNING SCREEN
  start_dsng_scrn: 'start_dsng_scrn',
  start_dsng_scrn_color: 'blue',

  //FINISH DESIGNING SCREEN
  fin_dsng_scrn: 'fin_dsng_scrn',
  fin_dsng_scrn_color: 'blue',

  screen_printing: 'screen_printing',
  screen_printing_color: 'blue',

  total_loss: 'totalLoss',
  total_loss_color: 'blue',

  stuck: 'stuck',
  stuck_color: 'blue',

  
  //DEPOSITS
  deposit_request:'deposit_request',
  deposit_request_color: 'brown',

  deposit_requested:'deposit_requested',
  deposit_requested_color:'teal',

  kimoto_printed:'kimoto_printed',
  kimoto_printed_color:'brown',

  confirm_order: 'confirm_order',
  confirm_order_color: 'purple',

  follow_up: 'follow_up',
  follow_up_color: 'yellow',

  image_note: 'image_note',
  image_note_color: 'image_note',

  order_update: 'order_update',
  order_update_color: 'order_update',
  

};



// WEBPACK FOOTER //
// ./src/config/OrderStatusConstants.js